import React from 'react';
import { Star, Play } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Teníamos el montacargas parado hace semanas y nadie le encontraba la falla. Llamamos a 2 de Abril, vinieron el mismo día y lo dejaron como nuevo. Volvimos a operar al otro día. Un alivio enorme.',
    initials: 'CR',
    name: 'Carlos R.',
    role: 'Encargado de depósito · Buenos Aires',
    bgColor: 'bg-primary'
  }, {
    text: 'Lo que más me sorprendió fue la atención. Gente humana, de verdad. Llegaron rápido, explicaron todo sin rodeos y el precio fue muy justo. Ya los recomendé a dos empresas del rubro.',
    initials: 'MP',
    name: 'Marcela P.',
    role: 'Dueña de empresa logística · GBA',
    bgColor: 'bg-avatar'
  }, {
    text: 'Tienen mecánicos que saben lo que hacen. Conocen las máquinas de verdad. Yo probé con otros talleres antes y nadie pudo. 2 de Abril lo resolvió en pocas horas. No llames a otro primero.',
    initials: 'RL',
    name: 'Roberto L.',
    role: 'Jefe de mantenimiento · Santa Fe',
    bgColor: 'bg-[#854F0B]'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-180">
      <div className="container mx-auto px-4" data-id="element-181">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-182">
          <span className="inline-block px-4 py-1.5 rounded-full bg-green-100 text-whatsappDark font-semibold text-sm mb-4" data-id="element-183">
            Lo que dicen nuestros clientes
          </span>
          <h2 className="text-gray-900 font-heading font-bold mb-4" data-id="element-184">
            Resultados reales. Clientes que volvieron a operar.
          </h2>
          <p className="text-gray-600 text-[17px]" data-id="element-185">
            Empresas que estuvieron paradas y hoy trabajan sin parar gracias a 2
            de Abril SRL.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-16" data-id="element-186">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 border-t-4 border-t-whatsapp flex flex-col h-full" data-id="element-187">
              <div className="flex gap-1 mb-4" data-id="element-188">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-accent text-accent" data-id="element-189" />)}
              </div>

              <p className="text-gray-700 italic text-[17px] leading-relaxed mb-8 flex-grow" data-id="element-190">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-191">
                <div className={`w-12 h-12 rounded-full ${testimonial.bgColor} text-accent flex items-center justify-center text-lg font-bold font-heading flex-shrink-0`} data-id="element-192">
                  {testimonial.initials}
                </div>
                <div data-id="element-193">
                  <h4 className="font-bold text-gray-900" data-id="element-194">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-195">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Video Block */}
        <div className="max-w-4xl mx-auto bg-primary rounded-2xl overflow-hidden shadow-xl" data-id="element-196">
          <div className="flex flex-col md:flex-row" data-id="element-197">
            <div className="p-8 md:p-12 flex-1 flex flex-col justify-center" data-id="element-198">
              <div className="w-12 h-12 rounded-full bg-whatsapp flex items-center justify-center mb-6" data-id="element-199">
                <Play className="w-6 h-6 text-white fill-white ml-1" data-id="element-200" />
              </div>
              <h3 className="text-white font-heading font-bold text-2xl mb-3" data-id="element-201">
                Testimonio en video
              </h3>
              <p className="text-subtitleDark text-[15px] leading-relaxed mb-6" data-id="element-202">
                Un cliente real cuenta su experiencia con 2 de Abril SRL. Mirá
                lo que dicen quienes ya confiaron en nosotros.
              </p>
              <div className="inline-block" data-id="element-203">
                <span className="bg-whatsapp/20 text-whatsapp px-3 py-1 rounded-full text-sm font-semibold border border-whatsapp/30" data-id="element-204">
                  Caso de éxito
                </span>
              </div>
            </div>

            <div className="md:w-1/2 relative bg-black min-h-[300px]" data-id="element-205">
              <video className="absolute inset-0 w-full h-full object-cover" controls poster="https://cdn.magicpatterns.com/uploads/k9H2GWynw6SofbYBFRDUmJ/Video Testimonio Beto 2deAbril.MOV" data-id="element-206">
                <source src="https://cdn.magicpatterns.com/uploads/k9H2GWynw6SofbYBFRDUmJ/Video Testimonio Beto 2deAbril.MOV" type="video/mp4" data-id="element-207" />
                Tu navegador no soporta el elemento de video.
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>;
}